"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AbstractCamera_active, _AbstractCamera_autoAdjust, _AbstractCamera_cameraMovementDuration, _AbstractCamera_defaultPosition, _AbstractCamera_defaultTarget, _AbstractCamera_domEventListenerToken, _AbstractCamera_eventListenerSceneCreatedToken, _AbstractCamera_eventListenerViewportUpdatedToken, _AbstractCamera_enableCameraControls, _AbstractCamera_far, _AbstractCamera_name, _AbstractCamera_near, _AbstractCamera_node, _AbstractCamera_order, _AbstractCamera_revertAtMouseUp, _AbstractCamera_revertAtMouseUpDuration, _AbstractCamera_sceneRotation, _AbstractCamera_useNodeData, _AbstractCamera_zoomExtentsFactor;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractCamera = void 0;
const viewer_shared_math_1 = require("@shapediver/viewer.shared.math");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const gl_matrix_1 = require("gl-matrix");
class AbstractCamera extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (24)
    // #region Constructors (1)
    constructor(_id, _type, version, _isDefault = false) {
        super(_id, version);
        this._id = _id;
        this._type = _type;
        this._isDefault = _isDefault;
        // #region Properties (24)
        _AbstractCamera_active.set(this, false);
        _AbstractCamera_autoAdjust.set(this, true);
        _AbstractCamera_cameraMovementDuration.set(this, 800);
        _AbstractCamera_defaultPosition.set(this, gl_matrix_1.vec3.create());
        _AbstractCamera_defaultTarget.set(this, gl_matrix_1.vec3.create());
        _AbstractCamera_domEventListenerToken.set(this, void 0);
        _AbstractCamera_eventListenerSceneCreatedToken.set(this, void 0);
        _AbstractCamera_eventListenerViewportUpdatedToken.set(this, void 0);
        _AbstractCamera_enableCameraControls.set(this, true);
        _AbstractCamera_far.set(this, 1000);
        _AbstractCamera_name.set(this, void 0);
        _AbstractCamera_near.set(this, 1);
        _AbstractCamera_node.set(this, void 0);
        _AbstractCamera_order.set(this, void 0);
        _AbstractCamera_revertAtMouseUp.set(this, false);
        _AbstractCamera_revertAtMouseUpDuration.set(this, 800);
        _AbstractCamera_sceneRotation.set(this, gl_matrix_1.vec2.create());
        _AbstractCamera_useNodeData.set(this, false);
        _AbstractCamera_zoomExtentsFactor.set(this, 1);
        this._eventEngine = viewer_shared_services_1.EventEngine.instance;
        this._stateEngine = viewer_shared_services_1.StateEngine.instance;
        this._boundingBox = new viewer_shared_math_1.Box();
        this._position = gl_matrix_1.vec3.create();
        this._target = gl_matrix_1.vec3.create();
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (44)
    get active() {
        return __classPrivateFieldGet(this, _AbstractCamera_active, "f");
    }
    set active(value) {
        __classPrivateFieldSet(this, _AbstractCamera_active, value, "f");
    }
    get autoAdjust() {
        return __classPrivateFieldGet(this, _AbstractCamera_autoAdjust, "f");
    }
    set autoAdjust(value) {
        __classPrivateFieldSet(this, _AbstractCamera_autoAdjust, value, "f");
    }
    set boundingBox(value) {
        this._boundingBox = value;
    }
    get cameraMovementDuration() {
        return __classPrivateFieldGet(this, _AbstractCamera_cameraMovementDuration, "f");
    }
    set cameraMovementDuration(value) {
        __classPrivateFieldSet(this, _AbstractCamera_cameraMovementDuration, value, "f");
    }
    get controls() {
        return this._controls;
    }
    get defaultPosition() {
        return __classPrivateFieldGet(this, _AbstractCamera_defaultPosition, "f");
    }
    set defaultPosition(value) {
        __classPrivateFieldSet(this, _AbstractCamera_defaultPosition, value, "f");
    }
    get defaultTarget() {
        return __classPrivateFieldGet(this, _AbstractCamera_defaultTarget, "f");
    }
    set defaultTarget(value) {
        __classPrivateFieldSet(this, _AbstractCamera_defaultTarget, value, "f");
    }
    get domEventListenerToken() {
        return __classPrivateFieldGet(this, _AbstractCamera_domEventListenerToken, "f");
    }
    set domEventListenerToken(value) {
        __classPrivateFieldSet(this, _AbstractCamera_domEventListenerToken, value, "f");
    }
    get enableCameraControls() {
        return __classPrivateFieldGet(this, _AbstractCamera_enableCameraControls, "f");
    }
    set enableCameraControls(value) {
        __classPrivateFieldSet(this, _AbstractCamera_enableCameraControls, value, "f");
    }
    get far() {
        return __classPrivateFieldGet(this, _AbstractCamera_far, "f");
    }
    set far(value) {
        __classPrivateFieldSet(this, _AbstractCamera_far, value, "f");
    }
    get id() {
        return this._id;
    }
    get isDefault() {
        return this._isDefault;
    }
    get name() {
        return __classPrivateFieldGet(this, _AbstractCamera_name, "f");
    }
    set name(value) {
        __classPrivateFieldSet(this, _AbstractCamera_name, value, "f");
    }
    get near() {
        return __classPrivateFieldGet(this, _AbstractCamera_near, "f");
    }
    set near(value) {
        __classPrivateFieldSet(this, _AbstractCamera_near, value, "f");
    }
    get node() {
        return __classPrivateFieldGet(this, _AbstractCamera_node, "f");
    }
    set node(value) {
        __classPrivateFieldSet(this, _AbstractCamera_node, value, "f");
    }
    get order() {
        return __classPrivateFieldGet(this, _AbstractCamera_order, "f");
    }
    set order(value) {
        __classPrivateFieldSet(this, _AbstractCamera_order, value, "f");
    }
    get position() {
        return this._position;
    }
    set position(value) {
        this._position = value;
        this._controls.position = value;
    }
    get revertAtMouseUp() {
        return __classPrivateFieldGet(this, _AbstractCamera_revertAtMouseUp, "f");
    }
    set revertAtMouseUp(value) {
        __classPrivateFieldSet(this, _AbstractCamera_revertAtMouseUp, value, "f");
    }
    get revertAtMouseUpDuration() {
        return __classPrivateFieldGet(this, _AbstractCamera_revertAtMouseUpDuration, "f");
    }
    set revertAtMouseUpDuration(value) {
        __classPrivateFieldSet(this, _AbstractCamera_revertAtMouseUpDuration, value, "f");
    }
    get sceneRotation() {
        return __classPrivateFieldGet(this, _AbstractCamera_sceneRotation, "f");
    }
    set sceneRotation(value) {
        __classPrivateFieldSet(this, _AbstractCamera_sceneRotation, value, "f");
    }
    get target() {
        return this._target;
    }
    set target(value) {
        this._target = value;
        this._controls.target = value;
    }
    get type() {
        return this._type;
    }
    get useNodeData() {
        return __classPrivateFieldGet(this, _AbstractCamera_useNodeData, "f");
    }
    set useNodeData(value) {
        __classPrivateFieldSet(this, _AbstractCamera_useNodeData, value, "f");
    }
    get viewportId() {
        return this._viewportId;
    }
    get zoomExtentsFactor() {
        return __classPrivateFieldGet(this, _AbstractCamera_zoomExtentsFactor, "f");
    }
    set zoomExtentsFactor(value) {
        __classPrivateFieldSet(this, _AbstractCamera_zoomExtentsFactor, value, "f");
    }
    // #endregion Protected Abstract Getters And Setters (1)
    // #region Public Methods (6)
    animate(path, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (path.length === 0)
                return Promise.resolve(false);
            if (!options)
                options = {};
            options.duration =
                options.duration >= 0
                    ? options.duration
                    : this.cameraMovementDuration;
            const res = yield this._controls.animate(path, options);
            if (res) {
                this._position = this._controls.position;
                this._target = this._controls.target;
            }
            return res;
        });
    }
    boundingSphereVisible(sphere) {
        const projectionMatrix = this.getProjectionMatrix(sphere);
        // if we cannot calculate the projection matrix, we assume the sphere is visible
        if (!projectionMatrix)
            return true;
        const planes = this.getFrustumPlanes(projectionMatrix);
        for (let i = 0; i < 6; i++) {
            const plane = planes[i];
            const distance = gl_matrix_1.vec3.dot([plane[0], plane[1], plane[2]], sphere.center) +
                plane[3];
            if (distance < -sphere.radius) {
                return false;
            }
        }
        return true;
    }
    destroy() {
        if (__classPrivateFieldGet(this, _AbstractCamera_eventListenerSceneCreatedToken, "f"))
            this._eventEngine.removeListener(__classPrivateFieldGet(this, _AbstractCamera_eventListenerSceneCreatedToken, "f"));
        __classPrivateFieldSet(this, _AbstractCamera_eventListenerSceneCreatedToken, undefined, "f");
        if (__classPrivateFieldGet(this, _AbstractCamera_eventListenerViewportUpdatedToken, "f"))
            this._eventEngine.removeListener(__classPrivateFieldGet(this, _AbstractCamera_eventListenerViewportUpdatedToken, "f"));
        __classPrivateFieldSet(this, _AbstractCamera_eventListenerViewportUpdatedToken, undefined, "f");
    }
    reset(options) {
        if (this.defaultPosition[0] === 0 &&
            this.defaultPosition[1] === 0 &&
            this.defaultPosition[2] === 0 &&
            this.defaultTarget[0] === 0 &&
            this.defaultTarget[1] === 0 &&
            this.defaultTarget[2] === 0) {
            return this.zoomTo(undefined, options);
        }
        else {
            return this.set(gl_matrix_1.vec3.clone(this.defaultPosition), gl_matrix_1.vec3.clone(this.defaultTarget), options);
        }
    }
    set(position, target, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!options)
                options = {};
            options.duration =
                options.duration >= 0
                    ? options.duration
                    : this.cameraMovementDuration;
            const res = yield this._controls.animate([
                {
                    position: gl_matrix_1.vec3.clone(this.position),
                    target: gl_matrix_1.vec3.clone(this.target),
                },
                { position, target },
            ], options);
            if (res) {
                this._position = this._controls.position;
                this._target = this._controls.target;
            }
            return res;
        });
    }
    update(time) {
        if (this.useNodeData && this.node && this._viewportId) {
            return true;
        }
        else {
            const { position, target, sceneRotation } = this._controls.update(time);
            let changed = true;
            if (gl_matrix_1.vec3.equals(position, this.position) &&
                gl_matrix_1.vec3.equals(target, this.target))
                changed = false;
            this.position = gl_matrix_1.vec3.clone(position);
            this.target = gl_matrix_1.vec3.clone(target);
            this.sceneRotation = gl_matrix_1.vec2.clone(sceneRotation);
            return changed;
        }
    }
    zoomTo(zoomTarget, options) {
        const { position, target } = this.calculateZoomTo(zoomTarget);
        return this.set(position, target, options);
    }
    // #endregion Public Abstract Methods (5)
    // #region Protected Methods (2)
    assignViewerInternal(viewportId) {
        this._viewportId = viewportId;
        this._eventEngine.addListener(viewer_shared_services_1.EVENTTYPE.SESSION.SESSION_CUSTOMIZED, () => __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _AbstractCamera_autoAdjust, "f") === true) {
                const innerListenerToken = this._eventEngine.addListener(viewer_shared_services_1.EVENTTYPE.VIEWPORT.VIEWPORT_UPDATED, () => __awaiter(this, void 0, void 0, function* () {
                    this.zoomTo();
                    this._eventEngine.removeListener(innerListenerToken);
                }));
            }
        }));
    }
    getFrustumPlanes(projectionMatrix) {
        const planes = [];
        for (let i = 0; i < 6; i++) {
            const plane = gl_matrix_1.vec4.create();
            switch (i) {
                case 0:
                    gl_matrix_1.vec4.set(plane, projectionMatrix[3] - projectionMatrix[0], projectionMatrix[7] - projectionMatrix[4], projectionMatrix[11] - projectionMatrix[8], projectionMatrix[15] - projectionMatrix[12]);
                    break; // Left
                case 1:
                    gl_matrix_1.vec4.set(plane, projectionMatrix[3] + projectionMatrix[0], projectionMatrix[7] + projectionMatrix[4], projectionMatrix[11] + projectionMatrix[8], projectionMatrix[15] + projectionMatrix[12]);
                    break; // Right
                case 2:
                    gl_matrix_1.vec4.set(plane, projectionMatrix[3] + projectionMatrix[1], projectionMatrix[7] + projectionMatrix[5], projectionMatrix[11] + projectionMatrix[9], projectionMatrix[15] + projectionMatrix[13]);
                    break; // Top
                case 3:
                    gl_matrix_1.vec4.set(plane, projectionMatrix[3] - projectionMatrix[1], projectionMatrix[7] - projectionMatrix[5], projectionMatrix[11] - projectionMatrix[9], projectionMatrix[15] - projectionMatrix[13]);
                    break; // Bottom
                case 4:
                    gl_matrix_1.vec4.set(plane, projectionMatrix[3] - projectionMatrix[2], projectionMatrix[7] - projectionMatrix[6], projectionMatrix[11] - projectionMatrix[10], projectionMatrix[15] - projectionMatrix[14]);
                    break; // Near
                case 5:
                    gl_matrix_1.vec4.set(plane, projectionMatrix[3] + projectionMatrix[2], projectionMatrix[7] + projectionMatrix[6], projectionMatrix[11] + projectionMatrix[10], projectionMatrix[15] + projectionMatrix[14]);
                    break; // Far
            }
            const length = Math.sqrt(Math.pow(plane[0], 2) + Math.pow(plane[1], 2) + Math.pow(plane[2], 2));
            if (length !== 0) {
                gl_matrix_1.vec4.scale(plane, plane, 1 / length);
            }
            planes.push(plane);
        }
        return planes;
    }
}
exports.AbstractCamera = AbstractCamera;
_AbstractCamera_active = new WeakMap(), _AbstractCamera_autoAdjust = new WeakMap(), _AbstractCamera_cameraMovementDuration = new WeakMap(), _AbstractCamera_defaultPosition = new WeakMap(), _AbstractCamera_defaultTarget = new WeakMap(), _AbstractCamera_domEventListenerToken = new WeakMap(), _AbstractCamera_eventListenerSceneCreatedToken = new WeakMap(), _AbstractCamera_eventListenerViewportUpdatedToken = new WeakMap(), _AbstractCamera_enableCameraControls = new WeakMap(), _AbstractCamera_far = new WeakMap(), _AbstractCamera_name = new WeakMap(), _AbstractCamera_near = new WeakMap(), _AbstractCamera_node = new WeakMap(), _AbstractCamera_order = new WeakMap(), _AbstractCamera_revertAtMouseUp = new WeakMap(), _AbstractCamera_revertAtMouseUpDuration = new WeakMap(), _AbstractCamera_sceneRotation = new WeakMap(), _AbstractCamera_useNodeData = new WeakMap(), _AbstractCamera_zoomExtentsFactor = new WeakMap();
//# sourceMappingURL=AbstractCamera.js.map